import { Component, ViewContainerRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { CustomerService } from '../../../services';
import { FilterModel, FilterResponseModel } from '../../../models';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'creator-search-result',
    templateUrl: './creator.search.result.component.html'
})

export class CreatorSearchResultComponent {
    @BlockUI('container-search-result') blockUI: NgBlockUI;

    public filterModel: FilterModel = new FilterModel();
    public isComponentInitiated = false;

    public filterResponse: FilterResponseModel = new FilterResponseModel();

    public resultSet: any = [];
    public pageCount: number;
    public totalRecords: number;
    public pageSize = 16;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private customerService: CustomerService) {
        this.toastr.setRootViewContainerRef(this.vcr);
        this.route.queryParams.subscribe(params => {
            if (params['q']) {
                this.filterModel.filterKey = params['q'];
            } else {
                this.filterModel.filterKey = null;
            }
        });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.filterCreators(1);
            }
        });
    }

    filterCreators(page: number) {
        this.blockUI.start();
        this.filterModel.pageNumber = page;
        this.filterModel.perPage = this.pageSize;
        this.pageCount = page;
        this.customerService.getCreators(this.filterModel)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    Object.assign(this.filterResponse, data);
                },
                error => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/components/creator/search-result/creator.search.result.component.ts